
















import Vue from 'vue';
import { OutlinedTextInput } from '@/components/ds';
import { formatPhoneInputAsTheUserTypes, isMobilePhoneValid } from '@/helpers/phone';

export interface ChangePhoneFormEvent {
  hasErrors: boolean;
  phone?: string;
}

export default Vue.extend({
  components: { OutlinedTextInput },
  props: {
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phone: '',
      masks: {
        phone: formatPhoneInputAsTheUserTypes,
      },
      hasFormErrors: false,
    };
  },
  methods: {
    inputHandler() {
      this.hasFormErrors = !!this.phone && !isMobilePhoneValid(this.phone);

      const event: ChangePhoneFormEvent = { hasErrors: this.hasFormErrors, phone: this.phone };

      this.$emit('input', event);
    },
  },
});
